import { render, staticRenderFns } from "./ArticleLicences.vue?vue&type=template&id=51e7c90c&"
import script from "./ArticleLicences.vue?vue&type=script&lang=ts&"
export * from "./ArticleLicences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports